// TODO: get a better way to store the namespace
export const namespace = "https://milkyway/";

// TODO: move to env variable (currently not working)
export const REACT_APP_API_ENDPOINT = "https://serious-energy-259513.appspot.com/api/v1";
// export const REACT_APP_API_ENDPOINT = "http://localhost:3002/api/v1";
